import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import useSendMFA from '../../resources/mfa/send';
import useMFATimeout from '../../hooks/useMFATimeout';

const PhoneResendMFA = () => {
  const { trigger } = useSendMFA();
  const [timeRemaining, onMFACodeSent] = useMFATimeout();

  const hasTimeRemaining = timeRemaining > 0;

  return (
    <Button
      onClick={() => {
        onMFACodeSent();
        trigger();
      }}
      disabled={hasTimeRemaining}
      startIcon={hasTimeRemaining && <CircularProgress size={18} color="info" />}
      variant="text"
    >
      {hasTimeRemaining ? `Sending, wait ${timeRemaining}s...` : 'Send New Code'}
    </Button>
  );
};

export default PhoneResendMFA;
